import React from "react";
import ReactTable from 'react-table-v6'
import '../../assets/css/Table.css'
import '../../assets/css/Transaction.css'
import circle from '../../assets/img/white_ellipse.png'
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios'
import moment from 'moment'
import Grid from '@material-ui/core/Grid';
import GridContainer from "../Grid/GridContainer.jsx";
import GridItem from "../Grid/GridItem.jsx";
import Card from "../Card/Card.jsx";
import CardBody from "../Card/CardBody.jsx";
import CardIcon from "../Card/CardIcon.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExportTo from '../Common/ExportTo'
import CustomDialog from '../Common/CustomDialog'
import { BASE_URL } from "../../utils/handleApi";

const styles = theme => ({
    button: {
        marginLeft: "10px",
        color: 'white',
        backgroundColor: '#04ab23',
        textTransform: 'none',
        fontFamily: 'Roboto-Medium',
        boxShadow: "none",
        borderRadius: 1,
        width: '100px',
        fontSize: "17px",
        '&:hover': {
          backgroundColor: '#04ab23'
        },
        '&:focus': {
          outline: 'none',
          backgroundColor: '#04ab23'
        },
      },

    select: {
        width: '12vw',
        height: "26px",
        border: 'none',
        boxShadow: '0px 0px 5px 0px #d6d6d6',
        // [theme.breakpoints.down('xs')]: {
        //   width: '40vw',

        // },
      },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "10px",
        [theme.breakpoints.down('xs')]:{
            marginTop:"25%"
        }
    },
});
class SearchOrderTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            persons:[],
            searchData: {},
            openDialogWhenNoData: false
        };
    }

    componentDidMount() {
        this.setState({ loading: true })
        let tokenStr = localStorage.getItem('token')
        const options = {
            headers: {
                'Authorization': `Bearer ${tokenStr}` 
            }
        };
        axios.post(`${BASE_URL}/lender/search`, this.props.searchData, options)
        .then(res => {
            const tempLenders =  res.data.map((lender, key) => ({
                id: key,
                name: lender.name,
                client_no: lender.client_no,
                billing_contact: lender.billing_contact,
                address: `${lender.street}, ${lender.city}, ${lender.state} - ${lender.zip}`,
            }))
            this.setState({ persons: tempLenders, loading: false});
        })
        .catch(err => {
            this.setState({ loading: false});
        })
    }
    exportPDF = () => {
        const { persons, openDialogWhenNoData } = this.state;
        if(persons.length === 0){
            return this.setState({ openDialogWhenNoData: !openDialogWhenNoData })
        }
        else {
            const unit = "pt";
            const size = "A4"; // Use A1, A2, A3 or A4
            const orientation = "landscape"; // portrait or landscape
    
            const marginLeft = 20;
            const doc = new jsPDF(orientation, unit, size);
    
            doc.setFontSize(15);
    
            const title = "My Lenders";
            const headers = [["Name", "Client No.", "Billing Contact Email", "Address" ]];
            
            const data2 = persons.map((prop, key) => ([
            prop.name,
            prop.client_no,
            prop.billing_contact,
            prop.address,
            ]))
    
            let content = {
            startY: 50,
            head: headers,
            body: data2
            };
    
            doc.text(title, marginLeft, 40);
            doc.autoTable(content);
            doc.save(`lenders_${moment().format('LLL')}`)
        }
      }

    exportExcel = () => {
    if(this.state.persons.length === 0){
        this.setState({ openDialogWhenNoData: !this.state.openDialogWhenNoData });
        return false
    }
    return true
    }

    render() {
        const { persons, loading, openDialogWhenNoData } = this.state;
        const { classes } = this.props;
        const dataExcel = persons.map((prop, key) => {
            return {
                "Name": prop.name,
                "Client No.": prop.client_no,
                "Billing Contact Email": prop.billing_contact,
                Address: prop.address,
            };
          })
        
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose" style={{ height: '65px', width: '63px' }}>
                                <img src={circle} alt="" height="23px" width="23px" style={{ marginLeft: '17%', marginTop: '12%' }} />
                            </CardIcon>
                       
                            <div className={classes.cardIconTitle}>
                                <Grid item xs={12}>
                                    <ExportTo 
                                        fileName={'lenders'}
                                        exportPDF={this.exportPDF}
                                        exportExcel={this.exportExcel}
                                        dataExcel={dataExcel}
                                    />
                                </Grid>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactTable
                                loading={loading}
                                NoDataComponent={() => !loading && <p style={{textAlign: "center", margin: "10px 0"}}>No Lenders Result available</p>}
                                data={persons}
                                columns={[
                                    {
                                        Header: "Name",
                                        accessor: "name",
                                    },
                                    {
                                        Header: "Client No",
                                        accessor: "client_no",
                                    },
                                    {
                                        Header: "Billing Contact Email",
                                        accessor: "billing_contact",
                                    },
                                    {
                                        Header: "Address",
                                        accessor: "address",
                                        headerStyle: { textAlign: "left" },
                                    },
                                ]}
                                style={{ width: '99%', border: 'none', whiteSpace: 'unset', marginLeft: 'auto', marginRight: 'auto' }}
                                defaultPageSize={10}
                                minRows={0}
                                showPaginationTop
                                showPaginationBottom={false}
                                className="-striped -highlight"
                                getTrGroupProps={() => {
                                    return {
                                        style: {
                                            borderBottom: "1px solid #d6d6d6",
                                        }
                                    }
                                }}
                                getPaginationProps={() => { return { style: { boxShadow: 'none', border: 'none', } } }}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <CustomDialog 
                    openDialog={openDialogWhenNoData}
                    closeDialog={() => this.setState({ openDialogWhenNoData: !openDialogWhenNoData })}
                />
            </GridContainer>
        );
    }
}

export default withStyles(styles)(SearchOrderTable);
